import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-2" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "text-base leading-6 font-semibold text-gray-700" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "ml-3 text-sm leading-5 font-normal text-gray-900" }

import { computed, onMounted, ref, watch } from "vue"
import { useWorkflowStore } from "@/stores/workflow"
import { getAttributesByCategories } from "@/shared/utils/helpers"
import { useGridCollectionStore } from "@/stores/grid-collection"
import { Attribute } from "@/shared/models/attributes"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import ArrowDown from "@/components/icons/ArrowDown.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PropertyValueChangeTriggerSidebar',
  setup(__props) {

const workflowStore = useWorkflowStore()
const gridCollectionStore = useGridCollectionStore()

const openGroups = ref<Record<string, boolean>>({})
const prototypes = computed(() => gridCollectionStore.prototypes)

function isValueChecked(value: string) {
    return workflowStore.selectedData
        ? !!(workflowStore.selectedData as Array<{ name: string; label: string }>).find(
              (el) => el.name === (value.includes(".") ? value.split(".")[1] : value)
          )
        : false
}

function onSelect(value: string, displayName: string) {
    if (workflowStore.selectedData) {
        if (isValueChecked(value)) {
            const index = (workflowStore.selectedData as Array<{ name: string; label: string }>).findIndex(
                (el) => el.name === (value.includes(".") ? value.split(".")[1] : value)
            )
            if (index === -1) return
            workflowStore.selectedData.splice(index, 1)
            return
        }
        ;(workflowStore.selectedData as Array<{ name: string; label: string }>).push({
            name: value.includes(".") ? value.split(".")[1] : value,
            label: displayName,
        })
    }
}

function getFilteredAttributes(attributes: Attribute[]) {
    return attributes
        .filter((attribute) => attribute.name !== "_id" && attribute.name !== "password")
        .sort((a, b) => a.displayName.localeCompare(b.displayName))
}

function toggleGroup(groupName: string) {
    openGroups.value[groupName] = !openGroups.value[groupName]
}

onMounted(async () => {
    gridCollectionStore.getPrototypesByPage("contacts")
    prototypes.value.forEach((prototype) => {
        const categories = getAttributesByCategories(prototype, [], true)
        categories.forEach((category) => {
            openGroups.value[category.name as string] = true
        })
    })
})

watch(
    () => workflowStore.selectedData,
    () => {
        workflowStore.areButtonDisabled = workflowStore?.selectedData?.length
            ? !workflowStore?.selectedData?.length
            : true
    },
    { deep: true }
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-lg leading-7 font-medium text-gray-900" }, "When following field value/s change:", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prototypes.value, (prototype) => {
      return (_openBlock(), _createElementBlock("div", {
        key: prototype.typeName
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAttributesByCategories)(prototype, [], true), (category) => {
          return (_openBlock(), _createElementBlock("div", {
            key: category._id
          }, [
            _createElementVNode("div", {
              class: "flex gap-x-2 pt-3 cursor-pointer",
              onClick: ($event: any) => (toggleGroup(category.name))
            }, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(category.displayName), 1),
              (openGroups.value[category.name])
                ? (_openBlock(), _createBlock(ArrowDown, {
                    key: 0,
                    class: "fill-gray-700"
                  }))
                : (_openBlock(), _createBlock(ArrowDown, {
                    key: 1,
                    class: "rotate-180 fill-gray-700"
                  }))
            ], 8, _hoisted_2),
            _createVNode(_Transition, { name: "fade" }, {
              default: _withCtx(() => [
                (openGroups.value[category.name])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getFilteredAttributes(category.attributes), (attribute) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: attribute._id,
                          class: "p-2.5 gap-x-2 text-sm leading-5 font-medium cursor-pointer hover:bg-gray-100 rounded-lg flex group",
                          onClick: ($event: any) => (onSelect(attribute.name, attribute.displayName))
                        }, [
                          _createVNode(GgmsCheckBox, {
                            checked: isValueChecked(attribute.name),
                            centered: true
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_6, _toDisplayString(attribute.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["checked"])
                        ], 8, _hoisted_5))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ]))
    }), 128))
  ]))
}
}

})